import React from 'react';
import { onClickLogoRio } from '../../shared';
import { DesktopHeaderContainer } from '../../styles/root';
import CheggLogo from '../shared/cheggLogo';
import SecondaryNav from '../shared/secondaryNav';
import CenterNav from './desktopCenterNav';

var DesktopHeader = function DesktopHeader(_ref) {
  var logo = _ref.logo,
      _onClickLogo = _ref.onClickLogo,
      activeLink = _ref.activeLink,
      navLinks = _ref.navLinks,
      secondaryNavLinks = _ref.secondaryNavLinks;
  return /*#__PURE__*/React.createElement(DesktopHeaderContainer, null, /*#__PURE__*/React.createElement(CheggLogo, {
    logo: logo,
    onClickLogo:
    /* istanbul ignore next */
    function onClickLogo(e) {
      onClickLogoRio();
      _onClickLogo === null || _onClickLogo === void 0 ? void 0 : _onClickLogo(e);
    }
  }), /*#__PURE__*/React.createElement(CenterNav, {
    navLinks: navLinks,
    activeLink: activeLink
  }), /*#__PURE__*/React.createElement(SecondaryNav, {
    secondaryNavLinks: secondaryNavLinks,
    activeLink: activeLink
  }));
};

DesktopHeader.displayName = 'DesktopHeader';
export default DesktopHeader;